<template>
<q-page class="main">
  <common-form :action="$route('mapgroup.update', {kaartgroep: mapGroup.id})" is-update>
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <item-header :item="mapGroup" />
        <div class="row q-col-gutter-md">
          <div class="col-xs-12 col-sm-6">
            <common-input
                v-model="form.title"
                label="Titel"
                name="title"
                :error-message="$errorMessage('title')"
                :error="$hasError('title')"
                required
            />
          </div>
          <div class="col-xs-12 col-sm-6">
            <q-select
                v-model="form.visibility"
                :options="visibilityOptions"
                label="Toepasbaar op"
                class="text-neutral-90"
                name="visibility"
                outlined
                map-options
                emit-value
                :error-message="$errorMessage('visibility')"
                :error="$hasError('visibility')"
            />
          </div>
        </div>
      </q-card-section>
      <q-card-actions class="q-pa-md">
        <warning-button v-if="!maps.data.length" label="Verwijder deze kaartgroep" @click="deleteMapGroup" />
        <accent-button label="Opslaan" type="submit" />
      </q-card-actions>
      <q-card-section class="page-card__details">
        <h2 class="heading-3 q-mb-md">
          Kaarten binnen {{ mapGroup.title }}
        </h2>
        <div
            class="row q-mt-lg"
            :class="maps.data.length ? 'justify-spread' : 'justify-end'"
        >
              <span v-if="!maps.data.length" class="col-shrink">
                 Lege kaartgroep
              </span>
          <template v-else>
            <div class="col-md-3 ">
              <q-list bordered separator>
                <q-item
                    v-for="map in maps.data"
                    :key="map.id"
                >
                  <q-item-section avatar>
                    <q-btn round @click="toggleHighlight(map)" flat
                           :aria-label="highlightedMapId === map.id ? `Toon heel ${mapGroup.title}`:`Toon de kaart van ${map.title}`"
                    >

                      <q-tooltip>
                        {{ highlightedMapId === map.id ? `Toon heel ${mapGroup.title}`:`Toon de kaart van ${map.title}` }}
                      </q-tooltip>
                      <q-icon v-if="highlightedMapId === map.id" name="visibility_off" />
                      <q-icon v-else name="visibility" />
                    </q-btn>
                  </q-item-section>
                  <q-item-section>
                    <a :href="$route('mapgroup.map.edit', { mapGroup_id: mapGroup.id, kaart: map.id })"
                       class="link link--primary">
                      {{ map.title }}
                    </a>
                  </q-item-section>
                </q-item>
                <q-item v-if="maps?.last_page > 1" class="flex flex-center">
                  <PaginationLinks :items="maps" />
                </q-item>
              </q-list>
            </div>
            <BaseMap
                class="col-md-9"
                auto-fit
                auto-fit-always
                :is-loading="geometryLoading"
                :geometry="visibleGeometry"
                width="100%"
                height="400px"
            />
          </template>
        </div>
      </q-card-section>
    </q-card>
  </common-form>
</q-page>
</template>

<script>
export default {
  props: {
    mapGroup: {
      type: Object,
      default: () => ({}),
    },
    maps: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      form: {
        title: this.$old('title', this.mapGroup.title),
        visibility: this.$old('visibility', this.mapGroup.visibility),
      },
      visibilityOptions: [
        {
          value: 1,
          label: 'Richtlijnbeheer',
        },
        {
          value: 3,
          label: 'Inrichtingselementen beheer',
        },
        {
          value: 2,
          label: 'Overal',
        }, ,
      ],
      geometryLoading: false,
      visibleGeometry: null,
      highlightedMapId: null,
      mapGroupGeometry: null,
    }
  },
  methods: {
    async deleteMapGroup () {
      if (!await this.$confirm({ title: 'Weet u zeker dat u deze kaartgroep wilt verwijderen?' })) {
        return
      }
      try {
        await axios.delete(this.$route('mapgroup.destroy', { mapGroup_id: this.mapGroup.id }))
        this.$toast('success', 'De kaartgroep is verwijderd')
        this.$goto('mapgroup.index')
      } catch (e) {
        console.error(e)
        this.$toast('error', 'De kaartgroep kon niet worden verwijderd')
      }
    },
    toggleHighlight (map) {
      if (this.highlightedMapId === map.id) {
        this.visibleGeometry = this.mapGroupGeometry
        this.highlightedMapId = null
      } else {
        this.highlightedMapId = map.id
        this.highlightMap(map)
      }
    },
    highlightMap (map) {
      this.geometryLoading = true
      axios.get(
          this.$route('api.map.show', { map: map.id }),
      ).then(({ data }) => {
        this.visibleGeometry = data
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.geometryLoading = false
      })
    },
    removeMapHighlight () {
      this.visibleGeometry = this.mapGroup.gis_geometry_collection
    },
  },
  mounted () {
    axios.get(
        this.$route('api.mapGroup.show', { mapGroupId: this.mapGroup.id }),
    ).then(({ data }) => {
      this.mapGroupGeometry = data
      if(!this.visibleGeometry){
        this.visibleGeometry = data
      }
    }).catch((e) => {
      console.log(e)
    }).finally(() => {
      this.geometryLoading = false
    })
  },
}
</script>
